<div class="task-detail-header modal-header">
    <span translate>job.task.details</span>
</div>
<div style="height: 40px"></div>
<div class="nav-sticky">
    <ul class="tab-list">
        <li [class.active]="subTab === 'incomplete'" (click)="subTabOnClick('incomplete')">
            <a translate>job.incomplete</a>
            <span class="activity-badbge">{{ taskCounts.incomplete }}</span>
        </li>
        <li [class.active]="subTab === 'completed'" (click)="subTabOnClick('completed')">
            <a translate>job.completed</a>
            <span class="activity-badbge">{{ taskCounts.completed }}</span>
        </li>
        <li [class.active]="subTab === 'skipped'" (click)="subTabOnClick('skipped')">
            <a translate>job.skipped</a>
            <span class="activity-badbge">{{ taskCounts.skipped }}</span>
        </li>
    </ul>
    <div class="search-container" [style.padding-right]="hasScrollbar ? '32px' : '16px'">
        <i class="fa fa-search search-icon"></i>
        <input type="text"
               class="form-control input-bottom-space"
               placeholder="Search"
               (input)="onSearch($event)"
               [(ngModel)]="searchText"
               appDebounceTimer/>
        <span style="height: 16px;" data-clear-input (click)="clearSearch()" *ngIf="searchText" class="clear-button">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                                d="M8 15C9.85652 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85652 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1C6.14348 1 4.36301 1.7375 3.05025 3.05025C1.7375 4.36301 1 6.14348 1 8C1 9.85652 1.7375 11.637 3.05025 12.9497C4.36301 14.2625 6.14348 15 8 15ZM5.78516 5.78516C6.04219 5.52812 6.45781 5.52812 6.71211 5.78516L7.99727 7.07031L9.28242 5.78516C9.53945 5.52812 9.95508 5.52812 10.2094 5.78516C10.4637 6.04219 10.4664 6.45781 10.2094 6.71211L8.92422 7.99727L10.2094 9.28242C10.4664 9.53945 10.4664 9.95508 10.2094 10.2094C9.95234 10.4637 9.53672 10.4664 9.28242 10.2094L7.99727 8.92422L6.71211 10.2094C6.45508 10.4664 6.03945 10.4664 5.78516 10.2094C5.53086 9.95234 5.52812 9.53672 5.78516 9.28242L7.07031 7.99727L5.78516 6.71211C5.52812 6.45508 5.52812 6.03945 5.78516 5.78516Z"
                                fill="#8E8E8E" />
                        </svg>
        </span>
    </div>
</div>
<div #activitiesScroll class="task-detail-body modal-body">
    <app-task-details
        [tab]="subTab"
        [tasks]="tasks"
        [loading]="loading"
        [error]="error"
        [diaryId]="diaryId"
        (taskDeleted)="loadTasks()">
    </app-task-details>
<!--    <div>-->
<!--        <input class="desc-box" placeholder="Type in a task description to add a task" appDebounceTimer/>-->
<!--    </div>-->
</div>
<div class="modal-footer task-detail-footer">
    <span (click)="close()" class="close-btn">Close</span>
</div>
